import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Pagination } from 'components'
import { promocodeActions } from 'redux/actionCreators'
import { get, omitBy, isNil } from 'lodash'
import { hasChanged, formatMoney } from 'helpers/utilities'
import { Link } from 'react-router'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import api from 'helpers/api'
import moment from 'moment'

import classes from './AdminPromocode.scss'

const unitMap = {
  'percent': '%',
  'baht': 'บาท'
}

const monthOptions = (() => {
  const options = []
  const lastMonth = moment().subtract(1, 'months')
  for (let i = 0; i < 24; i++) {
    const m = moment(lastMonth).subtract(i, 'months')
    options.push({ value: m.format('MM/YYYY'), label: m.format('MM/YYYY') })
  }
  return options
})()

@connect(state => ({
  promocodes: get(state, 'promocode.promocodes') || [],
  pageCount: get(state, 'promocode.pageCount') || 0
}), dispatch => ({
  attemptFindAllPromocodes: (payload) =>
    dispatch(promocodeActions.attemptFindAllPromocodes({ ...payload, limit: 100 }))
}))

class AdminPromocodes extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      selectedMonth: moment().subtract(1, 'months').format('MM/YYYY'),
      downloading: false
    }
  }

  _onDownloadSummary = () => {
    this.setState({ downloading: true })
    api.findPromocodeSummary({ month: this.state.selectedMonth })
      .then((res) => {
        const data = get(res, 'body') || []
        if (!data.length) {
          alert('ไม่พบข้อมูลการใช้โปรโมชันในเดือนที่เลือก')
          this.setState({ downloading: false })
          return
        }
        const BOM = '\uFEFF'
        const header = 'เดือน/ปี,ชื่อร้านค้า,รหัสลูกค้า,โค้ดส่วนลด,จำนวน'
        const rows = data.map(r =>
          `${r.month},"${(r.pharmacyName || '').replace(/"/g, '""')}",${r.userId},${r.promoCode},${r.count}`
        )
        const csv = BOM + [header, ...rows].join('\n')
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `promocode-summary-${this.state.selectedMonth.replace('/', '-')}.csv`
        link.click()
        URL.revokeObjectURL(url)
        this.setState({ downloading: false })
      })
      .catch(() => {
        alert('เกิดข้อผิดพลาดในการดาวน์โหลด')
        this.setState({ downloading: false })
      })
  }

  _renderRow = ({ code, discount, unit, quota, minimumSpend, validFrom, validUntil, status }) =>
    <tr key={code}>
      <td className='text-center'>{code}</td>
      <td className='text-center'>{discount} {unitMap[unit]}</td>
      <td className='text-center'>{quota ? `${quota} ครั้ง` : 'ไม่กำหนด'}</td>
      <td className='text-center'>{minimumSpend ? `${formatMoney(minimumSpend)} บาท` : 'ไม่กำหนด'}</td>
      <td className='text-center'>{validFrom || 'ไม่ระบุ'}</td>
      <td className='text-center'>{validUntil || 'ไม่ระบุ'}</td>
      <td className='text-center'>{status === 'active' ? 'ใช้งาน' : 'ไม่ใช้งาน'}</td>
      <td className='text-center'>
        <img src='/images/icon-pencil-orange.png'
          alt='icon-pencil-orange'
          onClick={() => this.context.router.push(`/admin/promocodes/${code}`)} />
      </td>
    </tr>

  _renderMobileRow = ({ code, discount, unit, quota, minimumSpend, validFrom, validUntil, status }) =>
    <div key={code} className='row'>
      <Link to={`/admin/promocodes/${code}`}>
        <div className='line'>
          <strong>PROMOCODE</strong>
          <span>{code}</span>
        </div>
        <div className='line'>
          <strong>ส่วนลด</strong>
          <span>{discount} {unitMap[unit]}</span>
        </div>
        <div className='line'>
          <strong>จำนวนครั้งที่ใช้ได้</strong>
          <span>{quota ? `${quota} ครั้ง` : 'ไม่กำหนด'}</span>
        </div>
        <div className='line'>
          <strong>ราคาขั้นต่ำที่ใช้ได้</strong>
          <span>{minimumSpend ? `${formatMoney(minimumSpend)} บาท` : 'ไม่กำหนด'}</span>
        </div>
        <div className='line'>
          <strong>วันที่เริ่มต้น</strong>
          <span>{validFrom || 'ไม่ระบุ'}</span>
        </div>
        <div className='line'>
          <strong>วันที่สิ้นสุด</strong>
          <span>{validUntil || 'ไม่ระบุ'}</span>
        </div>
        <div className='line'>
          <strong>สถานะ</strong>
          <span>{status === 'active' ? 'ใช้งาน' : 'ไม่ใช้งาน'}</span>
        </div>
      </Link>
      <img className='rowArrow' src='/images/icon-arrow-right.png' alt='icon-arrow-right' />
    </div>

  componentWillMount () {
    this._findPromocodes()
  }

  componentWillReceiveProps (nextProps) {
    if (hasChanged(this.props, nextProps, ['location', 'query'])) {
      this._findPromocodes(nextProps)
    }
  }

  _onAdd = () =>
    this.context.router.push('/admin/promocodes/new');

  _findPromocodes = (props = this.props) => {
    const query = get(props, 'location.query') || {}
    this.props.attemptFindAllPromocodes(omitBy({
      offset: (parseInt(query.page || 1, 10) - 1) * 100
    }, isNil))
  }

  render () {
    const { promocodes, pageCount, location } = this.props
    return (
      <section className={classes.promocodes}>
        <div className='relative' style={{ height: 50 }}>
          <Pagination router={this.context.router} location={location} pageCount={pageCount} />
          <div className='buttons'>
            <div className={classes.downloadSection}>
              <div className={classes.monthSelect}>
                <Select
                  value={this.state.selectedMonth}
                  options={monthOptions}
                  clearable={false}
                  searchable={false}
                  onChange={({ value }) => this.setState({ selectedMonth: value })}
                />
              </div>
              <div className='btn btn-orange' onClick={!this.state.downloading ? this._onDownloadSummary : undefined}
                style={this.state.downloading ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>
                <span>{this.state.downloading ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดสรุปโปรโมชัน'}</span>
              </div>
            </div>
            <div className='btn btn-orange' onClick={this._onAdd}>
              <span>เพิ่ม PROMOCODE</span>
            </div>
          </div>
        </div>
        <table className='with-stripe desktop'>
          <thead>
            <tr>
              <td className='text-center'>PROMOCODE</td>
              <td className='text-center'>ส่วนลด</td>
              <td className='text-center'>จำนวนครั้งที่ใช้ได้</td>
              <td className='text-center'>ราคาขั้นต่ำที่ใช้ได้</td>
              <td className='text-center'>วันที่เริ่มต้น</td>
              <td className='text-center'>วันที่สิ้นสุด</td>
              <td className='text-center'>สถานะ</td>
              <td className='text-center'>แก้ไข</td>
            </tr>
          </thead>
          <tbody>{promocodes.map(this._renderRow)}</tbody>
          {!promocodes.length && <tr><td className='text-center' colSpan='11'>ยังไม่มีรายการ PROMOCODE</td></tr>}
        </table>
        <section className='list'>
          {promocodes.map(this._renderMobileRow)}
        </section>
        <Pagination router={this.context.router} location={location} pageCount={pageCount} />
      </section>
    )
  }
}

export default AdminPromocodes



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminPromocode/AdminPromocodes.js